
import Recaptcha from "../shared/Recaptcha.vue";
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  props: ["visado"],
  components: { Recaptcha },
  data() {
    return {
      registradaHace: "",
      fechaFinalizacion: "",
      finalizadoHace: "",
      finalizado: false,
      notaSalida: "",
      recaptchaRequest: ""
    };
  },
  mounted() {
    this.tiempoTotal();
    const tiempoInterval = setInterval(() => {
      if (this.finalizado) {
        clearInterval(tiempoInterval);
      }
      this.tiempoTotal();
    }, 10000);
  },
  methods: {
    tiempoTotal() {
      const fecha = moment(this.visado.fechaEntada).fromNow();
      this.registradaHace = fecha;
    },
    formatearFecha(fecha: string): string {
      const resultado = moment(fecha).format("DD [a las] HH:mm");
      return resultado[0].toUpperCase() + resultado.slice(1);
    },
    setKeyRecaptcha(key: string) {
      this.recaptchaRequest = key;
    },
    visarSalida() {
      this.$dialog.prompt({
        title: "Confirmar",
        message: "¿Estás seguro que quieres visar la salida?",
        cancelText: "Cerrar",
        confirmText: "Aceptar",
        type: "is-info",
        hasIcon: true,
        inputAttrs: {
          placeholder: "Nota:",
          type: "text",
          minLenght: 10,
          required: false
        },
        onConfirm: async val => {
          const visadoCompleto = {
            ...this.visado,
            notaSalida: val,
            keyRecaptcha: this.recaptchaRequest
          };

          this.$http
            .put("Registra/salida", visadoCompleto, {
              headers: {
                Authorization: `Bearer ${this.$store.state.jwt}`
              }
            })
            .then(res => {
              this.$toast.open({
                message: "Registrado correctamente!",
                type: "is-success",
                position: "is-bottom"
              });
              this.finalizado = true;
              this.notaSalida = res.data.notaSalida;
              this.fechaFinalizacion = moment().format();
              this.finalizadoHace = moment(this.visado.fechaEntada)
                .from(this.fechaFinalizacion)
                .slice(4);
            })
            .catch(err => {
              this.$toast.open({
                message:
                  err.response.status != 500
                    ? err.response.data || "Error al registrar la entrada"
                    : "Error al registrar la entrada",
                type: "is-danger",
                position: "is-bottom"
              });
            });
        }
      });
    }
  }
});
